import type { ReactNode } from "react";
import styles from "./IconButton.module.css";

type IconButtonVariant = "ghost" | "secondary";
type IconButtonSize = "sm" | "md";

interface IconButtonProps {
  readonly icon: ReactNode;
  readonly "aria-label": string;
  readonly onClick?: () => void;
  readonly type?: "button" | "submit";
  readonly variant?: IconButtonVariant;
  readonly size?: IconButtonSize;
  readonly disabled?: boolean;
  readonly className?: string;
}

export function IconButton({
  icon,
  "aria-label": ariaLabel,
  onClick,
  type = "button",
  variant = "ghost",
  size = "md",
  disabled,
  className,
}: IconButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`${styles.button} ${styles[variant]} ${styles[size]} ${className ?? ""}`}
    >
      {icon}
    </button>
  );
}
